import { Box, Card, Typography, styled } from "@mui/material";

export const CardGrid = styled(Card)(({ theme }) => ({
  display: "grid",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gridTemplateColumns: `minmax(45%, 2fr) minmax(25%, 1fr) ${theme.spacing(
    5 * 5 + 4, // 5 rows of 40px and gaps of 8px
  )}`,
  padding: theme.spacing(3),
  /**
   * Linear scaling of gap from 24px at 1200px screen width to 40px at 1536px
   *
   * 1536px * percent + offset = 40px
   * 1200px * percent + offset = 24px
   * --- subtract ---
   * 336px * percent = 16px
   * percent = 16px / 336px = 0.0476 ~ 0.05
   * offset = 24px - 1200px * 0.05 = -36px
   * ---
   * gap = 0.05 * screen width - 36px
   */
  columnGap: `calc(max(5vw - ${theme.spacing(4.5)}, ${theme.spacing(3)}))`,
  ".plot": {
    height: "100%",
    aspectRatio: "1 / 1",
    "text.annotation-text": {
      textAnchor: "end",
    },
    ".js-plotly-plot .plotly .cursor-pointer": {
      cursor: "default",
      pointerEvents: "none",
    },
  },
}));

export const ActivityList = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: theme.spacing(1),
}));

export const CountGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gridTemplateColumns: "1fr auto",
  rowGap: theme.spacing(1),
  ".countLink": {
    height: theme.spacing(5),
    justifyContent: "center",
    overflow: "hidden",
  },
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  gridRow: 2,
  marginBottom: theme.spacing(2),
}));

export const PlotHeader = styled(SubTitle)(() => ({
  justifySelf: "center",
}));

export const Count = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "IBM Plex Mono",
  fontSize: theme.spacing(3),
  fontWeight: 600,
  justifySelf: "end",
}));
